module.exports = __webpack_public_path__ + "img/hero-mobile@2x.12f5e24b.jpg";